import { render, staticRenderFns } from "./cmp-dialog-scorequery.vue?vue&type=template&id=fa63f278&scoped=true"
import script from "./cmp-dialog-scorequery.vue?vue&type=script&lang=js"
export * from "./cmp-dialog-scorequery.vue?vue&type=script&lang=js"
import style0 from "./cmp-dialog-scorequery.vue?vue&type=style&index=0&id=fa63f278&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa63f278",
  null
  
)

export default component.exports